export default [
  {
    title: 'مدیریت تورها',
    icon: 'bx bx-chalkboard',
    children: [
      {
        title: 'تورها',
        route: { name: 'tour' },
        resource: 'TourManager',
        action: 'show',
      },
      {
        title: 'دسته‌بندی‌ها',
        route: { name: 'tourcategory' },
        resource: 'TourCategoryManager',
        action: 'show',
      },
      {
        title: 'هتل‌ها',
        route: { name: 'hotel' },
        resource: 'HotelManager',
        action: 'show',
      },
      {
        title: 'ایرلاین‌ها',
        route: { name: 'airline' },
        resource: 'AirlineManager',
        action: 'show',
      },
      {
        title: 'فرودگاه‌ها',
        route: { name: 'airport' },
        resource: 'AirportManager',
        action: 'show',
      },
      {
        title: 'شهرها',
        route: { name: 'city' },
        resource: 'CityManager',
        action: 'show',
      },
      {
        title: 'کشورها',
        route: { name: 'country' },
        resource: 'CountryManager',
        action: 'show',
      },
    ],
  },
]
